const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/components/Home.vue'),
    meta: {
      title: 'Home',
      layout: 'hub'
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('@/components/Contact.vue'),
    meta: {
      title: 'Contact',
      layout: 'hub'
    }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () => import('@/components/Login.vue'),
    meta: {
      title: 'Admin',
    }
  },
  {
    path: '/modsEdit',
    name: 'ModsEdit',
    component: () => import('@/components/Admin.vue'),
    meta: {
      title: 'ModsEdit',
    }
  },
  // {
  //   path: '*',
  //   component: () => import('@/components/HelloWorld.vue'),
  // }
];

export { routes };
